import { dynamic } from '#/utils/dynamic';

export const userProfileModalComponentByType = {
  UNFOLLOW: dynamic(
    () =>
      import('./Unfollow/UnfollowModal').then((module) => ({
        default: module.UnfollowModal,
      })),
    { strategy: 'always' },
  ),
  CREATE_USER_PROFILE: dynamic(
    () =>
      import('./CreateProfile/CreateProfileModal').then((module) => ({
        default: module.CreateProfileModal,
      })),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
